import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import OpeningAnimation from '../../components/feature/OpeningAnimation'; // TODO: オープニングアニメーション（一時的に無効化中）

const HomePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sinax.co.jp';
    
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "株式会社SINAX",
      "url": siteUrl,
      "logo": `${siteUrl}/vite.svg`,
      "description": "東京都千代田区の株式会社SINAXは、ITコンサルティング、PMO支援、SES事業を通じて、人と人の縁を起点に構想から実行まで伴走する実行型のITパートナーです。",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "神田須田町1丁目7番8号 VORT秋葉原Ⅳ 2F",
        "addressLocality": "千代田区",
        "addressRegion": "東京都",
        "postalCode": "101-0041",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "35.6938",
        "longitude": "139.7734"
      },
      "foundingDate": "2025-12",
      "founder": {
        "@type": "Person",
        "name": "村永 裕一"
      }
    };

    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "SINAX",
      "url": siteUrl,
      "description": "ITコンサルティング、PMO支援、SES事業を提供する株式会社SINAX",
      "publisher": {
        "@type": "Organization",
        "name": "株式会社SINAX"
      }
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(websiteSchema);
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return (
    <>
      <OpeningAnimation />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
